function initTopsort(token) {
  window.TS = {
    token: token || '',
    url: "https://api.topsort.com"
  };

  require('@topsort/analytics.js/dist/ts');
}

function getCookie(name) {
  let pattern = new RegExp('(^|;\\s*)(' + name + ')=([^;]*)');
  let match = document.cookie.match(pattern);
  return match ? match[3] : undefined;
}


function setCookie(name, value) {
  const date = new Date();
  date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000)); // 30 дней в миллисекундах
  const expires = "expires=" + date.toUTCString();
  document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + ";" + expires + ";path=/;domain=" + fakeWindow.location.hostname;
}

function initTopsortUserId() {
  let existCookie = getCookie("BX_TOPSORT_USER_ID"),
    tsuidCookie = getCookie("tsuid");

  if (existCookie !== undefined && existCookie === tsuidCookie || tsuidCookie === undefined) {
    return;
  }

  setCookie("BX_TOPSORT_USER_ID", tsuidCookie);
}

export { initTopsort, initTopsortUserId };
